import { render, staticRenderFns } from "./SPIFProfileRatios.vue?vue&type=template&id=102ddd7b"
import script from "./SPIFProfileRatios.vue?vue&type=script&lang=js"
export * from "./SPIFProfileRatios.vue?vue&type=script&lang=js"
import style0 from "./SPIFProfileRatios.vue?vue&type=style&index=0&id=102ddd7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports